import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c6db4c38&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=c6db4c38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6db4c38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6db4c38')) {
      api.createRecord('c6db4c38', component.options)
    } else {
      api.reload('c6db4c38', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c6db4c38&scoped=true&", function () {
      api.rerender('c6db4c38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics/logistics-self-point-management/modules/delivery-edit-log-dialog/index.vue"
export default component.exports